import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { Typography } from "@/react/components/shared/uikit/Typography";

const localeNamespace = "settings.workflows.templates.labels.email_hub";

export function EmailHubLabel() {
  return (
    <div className="flex h-5 items-center gap-1 rounded pe-1 hover:bg-[#3B82F6]/10">
      <TippyV2
        className="flex"
        interactive={false}
        key={t([localeNamespace, "description"])}
        content={t([localeNamespace, "description"])}
        placement="top"
        arrow={false}
        tooltipTextClassName="!max-w-[210px]"
      >
        <Icon type="10-diagonal-send" size={10} className="text-date-blue" />
        <Typography.LabelXxs color="text-date-blue">
          {t([localeNamespace, "label"])}
        </Typography.LabelXxs>
      </TippyV2>
    </div>
  );
}
